import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Article } from '../blog-models/Article';

@Component({
  selector: 'app-confirm-new-article',
  templateUrl: './confirm-new-article.component.html',
  styleUrls: ['./confirm-new-article.component.scss']
})
export class ConfirmNewArticleComponent implements OnInit {

    article: Article;

    constructor( private activatedRoute: ActivatedRoute) { }

    ngOnInit(): void {
        this.article.title = this.activatedRoute.snapshot.params['title'];
        this.article.pathImg = this.activatedRoute.snapshot.params['pathImg'];
        this.article.content = this.activatedRoute.snapshot.params['content'];

        console.log(this.article);
        
    }

}
